import { createSlice } from '@reduxjs/toolkit';
import { doAddToCart, destroyLineItems } from 'shared/product_tabs/cart/thunks';

const cartSlice = createSlice({
  name: 'cartSlice',
  initialState: {
    addingToCart: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(doAddToCart.pending, (state) => {
        state.addingToCart = true;
      })
      .addCase(doAddToCart.fulfilled, (state) => {
        state.addingToCart = true;
      })
      .addCase(doAddToCart.rejected, (state) => {
        state.addingToCart = false;
      })
      .addCase(destroyLineItems.pending, (state) => {
        state.addingToCart = true;
      })
      .addCase(destroyLineItems.fulfilled, (state) => {
        state.addingToCart = true;
      })
      .addCase(destroyLineItems.rejected, (state) => {
        state.addingToCart = false;
      });
  },
});

export default cartSlice.reducer;
